import React, {useRef} from 'react';
import "./../../assets/styles/styles.css";
import "./styles.css";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimesCircle as closeWindowIcon} from '@fortawesome/free-solid-svg-icons';

function ModalF({onBackgroundPress, contentComponent}){

    const background = useRef(null);
    const clickBackground = (event) => {
        if(event.target === background.current){
            onBackgroundPress();
        }
    }
    const defaultGrid = "col-12";

    return(
        <div className="row m-0 justify-content-center h-100 align-items-center contFixed p-3" ref={background} onClick={(event) => clickBackground(event)}>
            <div className={`cont-modal-f ${defaultGrid}`}>
                <div className="row m-0 justify-content-between w-100 align-items-center" style={{padding:10, borderBottom:"solid 1px grey"}}>
                    <div style={{fontWeight:"bold", flex:1, textAlign:"center"}}>OPINIÓNES</div>
                    <FontAwesomeIcon onClick={() => onBackgroundPress()} icon={closeWindowIcon} style={{fontSize:40, color:"#0056b3"}}/>
                </div>
                {contentComponent()}
            </div>
        </div>
    );

}

export default ModalF;
  